export const DEFAULT_COMPANY = {
  id: null,
  type_of_employment: 1,
  name: '',
  address_line_1: '',
  address_line_2: '',
  postcode: '',
  city: '',
  country: '',
  ombudsman_offices: [],
  job_function: '',
  job_position: '',
  confirmation_of_employment_files: [],
  liability_insurance_files: [],
  document_of_affiliation_files: [],
};
